import { useContext } from "react";
import { StoreContext } from "../../store/Store";
import { actionTypes } from "../../store/storeTypes";
import Close from "../../images/close.png";
import NewWindow from "../../images/newwindow.png";

const panelStyle = {
  position: "absolute",
  right: 10,
  top: 10,
  zIndex: 10,
  display: "flex",
  gap: 10,
};
const closeStyle = {
  height: 15,
  width: 15,
  cursor: "pointer",
};

const imageStyle = {
  width: 20,
  height: 20,
  pointerEvents: "none",
  cursor: "pointer",
};

export const ScreenShotButtons = () => {
  const [store, dispatch] = useContext(StoreContext);
  const { screenshotImage } = store;

  const onClose = () => {
    dispatch({
      type: actionTypes.SET_SCREENSHOT_IMAGE_DIMENSIONS,
      payload: null,
    });
    dispatch({
      type: actionTypes.SET_SCREENSHOT_IMAGE,
      payload: { image: null, active: false },
    });
  };
  const onExpand = () => {
    // dispatch({
    //   type: actionTypes.SET_SCREENSHOT_IMAGE,
    //   payload: { ...screenshotImage, active: false },
    // });

    window.open(screenshotImage.image, "_blank");
  };

  return (
    <div style={panelStyle}>
      <div style={closeStyle} onClick={() => onExpand()}>
        <img alt="NewWindow" src={NewWindow} style={imageStyle}></img>
      </div>
      <div style={closeStyle} onClick={() => onClose()}>
        <img alt="Close" src={Close} style={imageStyle}></img>
      </div>
    </div>
  );
};
